import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  COOKIE_CONSENT_ACCEPTED,
  COOKIE_CONSENT_KEY,
  COOKIE_CONSENT_REJECTED,
  getCookieConsent,
  trackPageView,
} from "../utils/analytics";

export const COOKIE_SETTINGS_EVENT = "cookie-settings-opened";

function CookieConsentBanner() {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const updateBannerVisibility = () => {
      setShowBanner(!getCookieConsent());
    };

    updateBannerVisibility();
    window.addEventListener(COOKIE_SETTINGS_EVENT, updateBannerVisibility);

    return () => {
      window.removeEventListener(COOKIE_SETTINGS_EVENT, updateBannerVisibility);
    };
  }, []);

  const saveChoice = (choice) => {
    localStorage.setItem(COOKIE_CONSENT_KEY, choice);
    setShowBanner(false);

    if (choice === COOKIE_CONSENT_ACCEPTED) {
      trackPageView();
    }
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="fixed inset-x-0 bottom-0 z-[90] border-t border-yellow-400/20 bg-black/95 px-4 py-3 text-white shadow-2xl shadow-black sm:px-6 sm:py-5">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 sm:gap-4 md:flex-row md:items-center md:justify-between">
        <p className="max-w-3xl text-xs font-medium leading-5 text-neutral-300 sm:text-sm sm:leading-6">
          We use cookies to improve your experience and understand website performance.
          You can accept analytics cookies or continue with only necessary cookies.{" "}
          <Link
            to="/privacy-policy"
            className="font-bold text-yellow-400 underline-offset-4 hover:underline"
          >
            Privacy Policy
          </Link>
        </p>

        <div className="grid w-full gap-2 sm:flex sm:w-auto sm:gap-3">
          <button
            type="button"
            onClick={() => saveChoice(COOKIE_CONSENT_ACCEPTED)}
            className="w-full rounded-xl bg-yellow-400 px-4 py-2.5 text-sm font-bold text-black transition hover:bg-yellow-300 sm:w-auto sm:rounded-2xl sm:px-5 sm:py-3"
          >
            Accept
          </button>

          <button
            type="button"
            onClick={() => saveChoice(COOKIE_CONSENT_REJECTED)}
            className="w-full rounded-xl border border-white/10 bg-white/[0.04] px-4 py-2.5 text-sm font-bold text-white transition hover:border-yellow-400/50 hover:text-yellow-300 sm:w-auto sm:rounded-2xl sm:px-5 sm:py-3"
          >
            Reject
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsentBanner;
